import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import EnglishDatePicker from '../components/EnglishDatePicker/EnglishDatePicker';

const API_URL = process.env.REACT_APP_API_URL || 'https://metro4.dcairo.com/api';

const EditPourModal = ({ pour, onClose, onUpdate }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    testType: '',
    date: '',
    station: '',
    element: '',
    mixCode: '',
    customMixCode: '',
    totalQuantity: '',
    cubesCount: { groups: '', cubesPerGroup: '' },
    chemicals: '',
    esCubes: '',
    startTime: '',
    finishTime: '',
    batchPlant: ''
  });

  useEffect(() => {
    if (pour) {
      setFormData({
        testType: pour.testType || 'Concrete',
        date: pour.castingDate ? new Date(pour.castingDate).toISOString().split('T')[0] : '',
        station: pour.station || '',
        element: pour.location || '',
        mixCode: pour.mix || 'C37/20 cem lll',
        customMixCode: '',
        totalQuantity: pour.quantity || '',
        cubesCount: {
          groups: pour.cubesCount?.groups || '',
          cubesPerGroup: pour.cubesCount?.cubesPerGroup || ''
        },
        chemicals: pour.chemistry || '',
        esCubes: pour.esCubes || '',
        startTime: pour.startTime || '',
        finishTime: pour.finishTime || '',
        batchPlant: pour.batchPlant || ''
      });
    }
  }, [pour]);

  const allStations = [
    { value: 'ST13 Giza', label: 'ST13 Giza' },
    { value: 'ST14 Giza Square', label: 'ST14 Giza Square' },
    { value: 'S15 Alrawda', label: 'S15 Alrawda' },
    { value: 'ST16 Almalek Elsaleh', label: 'ST16 Almalek Elsaleh' },
    { value: 'ST17 Cut&Cover', label: 'ST17 Cut&Cover' },
    { value: 'Abo Rawash', label: 'Abo Rawash Lab' },
    { value: '4TL', label: '4TL Lab' }
  ];

  const batchPlants = ['Abo Rawash', 'Unimix', 'Green'];
  const mixCodes = [
    'C1 /slurry',
    'C20/20 opc',
    'C25/20 opc',
    'C37/20 cem lll',
    'C37/10 cem lll',
    'C37/20 cem lll mass',
    'C50/20 cem lll',
    'C50/10 cem lll',
    'Custom'
  ];
  const testTypes = ['Concrete', 'Trail', 'Grout'];

  const formatDateForAPI = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      
      const finalMixCode = formData.mixCode === 'Custom' ? formData.customMixCode : formData.mixCode;
      
      if (formData.mixCode === 'Custom' && !formData.customMixCode.trim()) {
        toast.error('الرجاء إدخال كود الخليط المخصص');
        setLoading(false);
        return;
      }
      
      const submitData = {
        testType: formData.testType,
        castingDate: formatDateForAPI(formData.date),
        station: formData.station,
        location: formData.element,
        mix: finalMixCode,
        quantity: formData.totalQuantity,
        cubesCount: formData.cubesCount,
        chemistry: formData.chemicals,
        esCubes: formData.esCubes || 0,
        startTime: formData.startTime,
        finishTime: formData.finishTime,
        batchPlant: formData.batchPlant
      };
      
      const response = await axios.put(`${API_URL}/pours/${pour._id}`, submitData, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data.success) {
        toast.success(response.data.message);
        onUpdate();
        onClose();
      }
    } catch (error) {
      console.error('Error updating pour:', error);
      toast.error(error.response?.data?.message || 'حدث خطأ أثناء التعديل');
    } finally {
      setLoading(false);
    }
  };

  const calculateCubesSampleNo = () => {
    const { groups, cubesPerGroup } = formData.cubesCount;
    if (groups && cubesPerGroup) {
      return parseInt(groups) * parseInt(cubesPerGroup);
    }
    return 0;
  };

  const cubesSampleNo = calculateCubesSampleNo();

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.6)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '20px',
      overflowY: 'auto'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        maxWidth: '900px',
        width: '100%',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <div style={{
          padding: '25px',
          borderBottom: '2px solid #f1f5f9',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          position: 'sticky',
          top: 0,
          background: 'white',
          zIndex: 1
        }}>
          <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '800', color: '#1e293b' }}>
            ✏️ تعديل الصبة
          </h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '28px',
              cursor: 'pointer',
              color: '#64748b',
              padding: '0',
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '8px',
              transition: 'all 0.2s'
            }}
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} style={{ padding: '25px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
            
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#475569' }}>
                Test Type <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <select
                value={formData.testType}
                onChange={(e) => setFormData({...formData, testType: e.target.value})}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '15px'
                }}
              >
                {testTypes.map(tt => (
                  <option key={tt} value={tt}>{tt}</option>
                ))}
              </select>
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#475569' }}>
                Station <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <select
                value={formData.station}
                onChange={(e) => setFormData({...formData, station: e.target.value})}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '15px'
                }}
              >
                <option value="">اختر المحطة</option>
                {allStations.map(st => (
                  <option key={st.value} value={st.value}>{st.label}</option>
                ))}
              </select>
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#475569' }}>
                Date <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <EnglishDatePicker
                selected={formData.date ? new Date(formData.date) : null}
                onChange={(date) => setFormData({...formData, date: formatDateForAPI(date)})}
                maxDate={new Date()}
                placeholderText="Select Date"
              />
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#475569' }}>
                Element <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <input
                type="text"
                value={formData.element}
                onChange={(e) => setFormData({...formData, element: e.target.value})}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '15px'
                }}
              />
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#475569' }}>
                Mix Code <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <select
                value={formData.mixCode}
                onChange={(e) => setFormData({...formData, mixCode: e.target.value, customMixCode: ''})}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '15px'
                }}
              >
                {mixCodes.map(mix => (
                  <option key={mix} value={mix}>{mix}</option>
                ))}
              </select>
            </div>

            {formData.mixCode === 'Custom' && (
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#475569' }}>
                  Custom Mix Code <span style={{ color: '#ef4444' }}>*</span>
                </label>
                <input
                  type="text"
                  value={formData.customMixCode}
                  onChange={(e) => setFormData({...formData, customMixCode: e.target.value})}
                  required
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #e2e8f0',
                    borderRadius: '8px',
                    fontSize: '15px'
                  }}
                />
              </div>
            )}

            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#475569' }}>
                Total Quantity (m³) <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <input
                type="number"
                step="0.01"
                value={formData.totalQuantity}
                onChange={(e) => setFormData({...formData, totalQuantity: e.target.value})}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '15px'
                }}
              />
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#475569' }}>
                Groups (G) <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <input
                type="number"
                value={formData.cubesCount.groups}
                onChange={(e) => setFormData({...formData, cubesCount: {...formData.cubesCount, groups: e.target.value}})}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '15px'
                }}
              />
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#475569' }}>
                Cubes Per Group <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <input
                type="number"
                value={formData.cubesCount.cubesPerGroup}
                onChange={(e) => setFormData({...formData, cubesCount: {...formData.cubesCount, cubesPerGroup: e.target.value}})}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '15px'
                }}
              />
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#3b82f6' }}>
                Cubes Sample No (محسوب)
              </label>
              <div style={{
                padding: '12px',
                background: '#f1f5f9',
                borderRadius: '8px',
                fontSize: '15px',
                fontWeight: '700',
                color: '#1e40af'
              }}>
                {cubesSampleNo > 0 ? `${formData.cubesCount.groups}G × ${formData.cubesCount.cubesPerGroup} = ${cubesSampleNo}C` : '- - -'}
              </div>
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#475569' }}>
                Chemicals (CH) <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <input
                type="number"
                value={formData.chemicals}
                onChange={(e) => setFormData({...formData, chemicals: e.target.value})}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '15px'
                }}
              />
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#475569' }}>
                E.S Cubes
              </label>
              <input
                type="number"
                value={formData.esCubes}
                onChange={(e) => setFormData({...formData, esCubes: e.target.value})}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '15px'
                }}
              />
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#475569' }}>
                Time Start <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <input
                type="time"
                value={formData.startTime}
                onChange={(e) => setFormData({...formData, startTime: e.target.value})}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '15px'
                }}
              />
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#475569' }}>
                Time Finish <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <input
                type="time"
                value={formData.finishTime}
                onChange={(e) => setFormData({...formData, finishTime: e.target.value})}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '15px'
                }}
              />
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#475569' }}>
                Batch Plant <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <select
                value={formData.batchPlant}
                onChange={(e) => setFormData({...formData, batchPlant: e.target.value})}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '15px'
                }}
              >
                <option value="">اختر المحطة</option>
                {batchPlants.map(plant => (
                  <option key={plant} value={plant}>{plant}</option>
                ))}
              </select>
            </div>

          </div>

          <div style={{ display: 'flex', gap: '15px', marginTop: '30px', justifyContent: 'flex-end' }}>
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              style={{
                padding: '14px 28px',
                background: '#f1f5f9',
                color: '#475569',
                border: 'none',
                borderRadius: '10px',
                fontSize: '16px',
                fontWeight: '700',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'all 0.3s'
              }}
            >
              إلغاء
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                padding: '14px 28px',
                background: loading ? '#94a3b8' : 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '10px',
                fontSize: '16px',
                fontWeight: '700',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'all 0.3s',
                boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)'
              }}
            >
              {loading ? '⏳ جاري الحفظ...' : '💾 حفظ التعديلات'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPourModal;